<!--
 * @Author: wjw this.wujiwen@gmail.com
 * @Date: 2022-11-03 11:42:01
 * @LastEditors: WeijianXu weijian.xu@unidt.com
 * @LastEditTime: 2024-05-09 11:37:10
 * @FilePath: \user-center\src\components\element\form.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<script lang="jsx">
export default {
  name: 'EForm',
  props: {
    options: {
      type: Array,
      default: () => [],
    },
    showLabel: {
      type: Boolean,
      default: true,
    }
  },
  methods: {
    validate(callback) {
      return this.$refs.form.validate(callback);
    },
    validateField(props) {
      return this.$refs.form.validateField(props);
    },
    resetFields(props) {
      return this.$refs.form.resetFields(props);
    },
    scrollToField(props) {
      return this.$refs.form.scrollToField(props);
    },
    clearValidate() {
      this.$refs.form.clearValidate();
    },
    submitForm(e) {
      // 解决只有一个输入框时，enter 键跳转的问题
      e.preventDefault();
      // 避免重名
      this.$emit('to-submit');

      e.stopPropagation();
    },
  },
  render() {
    const items = this.options.map((e) => {
      let { render, label, ...rest } = e;
      if (!this.showLabel) {
        label = '';
      }
      return <el-form-item {...rest} label={label} >{render && render()}</el-form-item>;
    });
    return (
      <el-form ref="form" onSubmit={this.submitForm}>
        {items}
      </el-form>
    )
  },
};
</script>
